import {CamelOrPascalToSnakeCase} from 'shared/web';

export type TireSetDetailTabId = 'tires' | 'tiresMovement' | 'tiresArchive';

export const TIRE_SET_DETAIL_TAB_IDS = {
  TIRES: 'tires',
  TIRES_MOVEMENT: 'tiresMovement',
  TIRES_ARCHIVE: 'tiresArchive',
} as const satisfies Record<
  Uppercase<CamelOrPascalToSnakeCase<TireSetDetailTabId>>,
  TireSetDetailTabId
>;
